module.exports = __webpack_public_path__ + "static/menu-ikeda-sengyo-min4-4863d5839ebdbff66a7361b74ec379f2.jpg";